(() => {
  document.querySelectorAll('[data-recipe-library]').forEach(library => {
    if (library.dataset.recipesReady) return;
    library.dataset.recipesReady = 'true';
    const controls = library.querySelector('[data-recipe-controls]');
    if (!controls) return;
    const search = controls.querySelector('[data-recipe-search]');
    const category = controls.querySelector('[data-recipe-category]');
    const buttons = [...controls.querySelectorAll('[data-recipe-kind]')];
    const cards = [...library.querySelectorAll('[data-recipe-card]')];
    let kind = '';
    const normalize = value => value.toLocaleLowerCase().replace(/[״׳'"\u0591-\u05c7]/g, '').replace(/\s+/g, ' ').trim();
    const update = () => {
      const terms = normalize(search.value).split(' ').filter(Boolean);
      let count = 0;
      cards.forEach(card => {
        const text = normalize(card.dataset.search || '');
        const visible = (!kind || card.dataset.kind === kind) && (!category.value || card.dataset.category === category.value) && terms.every(term => text.includes(term));
        card.hidden = !visible;
        if (visible) count++;
      });
      library.querySelector('[data-recipe-count]').textContent = String(count);
      library.querySelector('[data-recipe-empty]').hidden = count > 0;
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.recipeKind === kind)));
    };
    search.addEventListener('input', update);
    category.addEventListener('change', update);
    buttons.forEach(button => button.addEventListener('click', () => { kind = button.dataset.recipeKind; update(); }));
    library.querySelector('[data-recipe-clear]').addEventListener('click', () => { search.value = ''; category.value = ''; kind = ''; update(); search.focus(); });
    controls.hidden = false;
    update();
  });
  document.querySelectorAll('[data-recipe-print]').forEach(button => {
    if (button.dataset.printReady) return;
    button.dataset.printReady = 'true';
    button.hidden = false;
    button.addEventListener('click', () => window.print());
  });
})();
